import React, { useState } from 'react';

import { GenericFieldProps } from '../util/types';

import * as styles from './styles';

export const InputField = function ({
  name,
  label,
  error,
  fieldInfoClassName,
  description,
  className,
  id,
  iconName,
  required,
  onFocus,
  onBlur,
  ...props
}: GenericFieldProps & JSX.IntrinsicElements['input']) {
  const [isFocused, setIsFocused] = useState(false);
  const prefix = React.useId();
  const inputId = id ?? `${prefix}-${name}`;

  const hasError = Boolean(error) && !isFocused;
  const hasDescription = Boolean(description);

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    if (onFocus) onFocus(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    if (onBlur) onBlur(e);
  };

  const raised = isFocused || Boolean(props.value) || Boolean(props.defaultValue) || props.type === 'date';

  return (
    <div css={styles.inputWrapper}>
      <div css={styles.fieldStyles}>
        {iconName && (
          <span css={styles.inputIconContainer}>
            <svg>
              <use href={`#${iconName}`} />
            </svg>
          </span>
        )}
        <input
          {...props}
          id={inputId}
          name={name}
          className={className}
          data-testid={`${name} input`}
          css={styles.inputStyles(hasError, isFocused, !!iconName)}
          placeholder={label}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />

        <label htmlFor={inputId} css={styles.fieldLabel(raised, !!iconName)}>
          {label}
          {required && <sup>*</sup>}
        </label>
      </div>

      {hasError && (
        <div css={[styles.fieldInfo, fieldInfoClassName]}>
          <p css={styles.error}>{error}</p>
        </div>
      )}
      {hasDescription && !hasError && (
        <div css={[styles.fieldInfo, fieldInfoClassName]}>
          <p css={styles.description}>{description}</p>
        </div>
      )}
    </div>
  );
};
